import Main from "./main";

// 本地永久存储
export const Local = new Main();
// 本地临时存储
export const Session = new Main('session');